import Vue from 'vue'
import { BootstrapVue, ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import CountryFlag from 'vue-country-flag'

import i18n from '@/libs/i18n'
import VueBreadcrumbs from 'vue-2-breadcrumbs'
import LanguageService from '@/api/client/language.service'
import router from './router'
import store from './store'
import App from './App.vue'
import filters from './utils/filters'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
// import '@/@fake-db/db'

// Boostrap Vue
Vue.use(BootstrapVue)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Filters
Vue.use(filters)

// Country flags
Vue.component('country-flag', CountryFlag)

// Composition API
Vue.use(VueCompositionAPI)

// Vue Breadcrumbs
Vue.use(VueBreadcrumbs, {
  template:
  '<div>\n'
    + '<div ref="pageTitle">\n'
     + ' {{ $tk($route.meta.pageTitle) }}\n'
    + '</div>\n'
    + '<b-breadcrumb class="py-0 pl-0">\n'
      + '<b-breadcrumb-item :to=\'$route.params.accountId === undefined ? "/" : "/" + $route.params.accountId \'>\n'
        + '{{ $tk("ClientPortal.SideMenu.Home") }}\n'
      + '</b-breadcrumb-item>\n'
      + '<b-breadcrumb-item\n'
       + ' v-for="item in $route.meta.breadcrumb"\n'
        + ':key="item.text"\n'
        + ':active="item.active"\n'
        + ':to=\'$route.params.accountId === undefined ? item.to : "/" + $route.params.accountId + item.to\'\n'
      + '>\n'
       + ' {{ $tk(item.text) }}\n'
      + '</b-breadcrumb-item>\n'
    + '</b-breadcrumb>\n'
  + '</div>',
})

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = true

new Vue({
  router,
  store,
  i18n,
  async beforeCreate() {
    const vm = this
    const languages = []
    const response = await LanguageService.getLanguageResources()
    Object.keys(response.AvailableLanguages).forEach(key => {
      languages.push(key)
      vm.$i18n.setLocaleMessage(`${key}`, response.AvailableLanguages[key])
    })
    if (response.UserLanguage != null) {
      vm.$i18n.locale = response.UserLanguage
    }
    if (languages.filter(x => x === vm.$i18n.locale).length === 0 && languages.length > 0) {
      const [defaultLanguage] = languages
      vm.$i18n.locale = defaultLanguage
    }
    // eslint-disable-next-line no-underscore-dangle
    vm.$i18n.setLocaleMessage(vm.$i18n.locale, vm.$i18n._getMessages()[vm.$i18n.locale])
  },
  render: h => h(App),
}).$mount('#app')
